/* eslint-disable import/prefer-default-export */
import React from 'react';
import PropTypes from 'prop-types';
import { dynamicAssets } from '../../../../../../utilities/helpers';
import { CARD_NETWORKS, cardProviders } from '../../../../../../screens/Card/constants';

export const OrderReplacementImage = ({ cardNetwork, cardProvider }) => {
  if (cardProvider === cardProviders.GALILEO && cardNetwork === CARD_NETWORKS.VISA) {
    return (
      <img
        style={{
          width: '100%',
          height: 'auto',
          marginTop: '1rem',
          resize: 'contain',
          alignSelf: 'center',
        }}
        src={dynamicAssets('./assets/images/reportVisacard.svg')}
        alt="Visa card"
      />
    );
  }

  return (
    <img
      style={{
        width: '100%',
        height: 'auto',
        marginTop: '1rem',
        resize: 'contain',
        alignSelf: 'center',
      }}
      src={dynamicAssets('./assets/images/reportMastercard.svg')}
      alt="masterCardSecurity"
    />
  );
};

OrderReplacementImage.propTypes = {
  cardProvider: PropTypes.string.isRequired,
  cardNetwork: PropTypes.string.isRequired,
};
